import {useState} from "react";
import MenuIcon from "@mui/icons-material/Menu";
import IconButton from "@mui/material/IconButton";
import {Drawer, Grid, List, ListItem, ListItemText, ThemeProvider} from "@mui/material";
import {StyledNavLink} from "./StyledNavLink";
import * as React from "react";
import {useLocation} from "react-router";
import {useTheme} from "@mui/system";
import BizLogo from "../../images/fulllogo_transparent_nobuffer.svg";


function DrawerMenu(props) {
  const [openDrawer, setOpenDrawer] = useState(false);
  const currentLocation = useLocation()
  const theme = useTheme();

  return (
    <div>
      <ThemeProvider theme={theme}>
        <Grid container direction={"row"} alignItems={"center"} justifyContent={"space-between"} columns={{xs: 4, sm: 4, md: 6}} >
          <Grid size={{xs: 1}}>
            <IconButton onClick={() => setOpenDrawer(!openDrawer)}>
              <MenuIcon fontSize={'large'}/>
            </IconButton>
          </Grid>
          <Grid size={{xs: 3}}>
            <Grid marginTop={1}>
              <img alt={''} src={BizLogo} width={'70%'} height={'70%'}/>
            </Grid>
          </Grid>
        </Grid>

        <Drawer open={openDrawer} onClose={() => setOpenDrawer(false)}>
            <List>
              <ListItem onClick={() => setOpenDrawer(false)}>
                <ListItemText>
                  <StyledNavLink className={`${currentLocation.pathname === '/' ? 'active' : undefined}`} to={'/'}>Home</StyledNavLink>
                </ListItemText>
              </ListItem>
              <ListItem onClick={() => setOpenDrawer(false)}>
                <ListItemText>
                  <StyledNavLink className={`${currentLocation.pathname === '/drops' ? 'active' : undefined}`} to={'/drops'}>Drops</StyledNavLink>
                </ListItemText>
              </ListItem>
              <ListItem onClick={() => setOpenDrawer(false)}>
                <ListItemText>
                  <StyledNavLink className={`${currentLocation.pathname === '/calendar' ? 'active' : undefined}`} to={'/calendar'}>Calendar</StyledNavLink>
                </ListItemText>
              </ListItem>
              <ListItem onClick={() => setOpenDrawer(false)}>
                <ListItemText>
                  <StyledNavLink className={`${currentLocation.pathname === '/menu' ? 'active' : undefined}`} to={'/menu'}>Menu</StyledNavLink>
                </ListItemText>
              </ListItem>
              <ListItem onClick={() => setOpenDrawer(false)}>
                <ListItemText>
                  <StyledNavLink className={`${currentLocation.pathname === '/contact' ? 'active' : undefined}`} to={'/contact'}>Contact</StyledNavLink>
                </ListItemText>
              </ListItem>
              <ListItem onClick={() => setOpenDrawer(false)}>
                <ListItemText>
                  <StyledNavLink className={`${currentLocation.pathname === '/about' ? 'active' : undefined}`} to={'/about'}>About</StyledNavLink>
                </ListItemText>
              </ListItem>

            </List>
        </Drawer>
      </ThemeProvider>
    </div>
  )
}

export {DrawerMenu}